/**
 * Shared map tile providers used across the app.
 * Primary: Google Maps tiles (high quality, Arabic labels, rich POIs for Iraq).
 * Fallback: ESRI/OSM (used if Google tiles are blocked).
 *
 * Modes (Feb 2026):
 *  - streets   : Google Maps roadmap (DEFAULT) — crisp Arabic labels, shops, mosques, POIs
 *  - satellite : Google Maps satellite — HD imagery
 *  - hybrid    : Google satellite + roads + labels overlay
 *  - terrain   : Google terrain — topographic look
 *  - osm       : OpenStreetMap fallback
 */

// Google Maps tile servers (mt0..mt3). Params:
//  lyrs=m    → roadmap
//  lyrs=s    → satellite only
//  lyrs=y    → hybrid (sat + labels)
//  lyrs=p    → terrain
//  hl=ar     → Arabic labels
//  gl=iq     → bias POIs for Iraq
const GOOGLE_BASE = "https://mt{s}.google.com/vt/lyrs={layer}&x={x}&y={y}&z={z}&hl=ar&gl=iq";

export const MAP_STYLES = {
  streets: {
    id: "streets",
    label: "شوارع",
    emoji: "🛣️",
    url: GOOGLE_BASE.replace("{layer}", "m"),
    subdomains: ["0", "1", "2", "3"],
    attribution: "© Google",
    maxZoom: 20,
    overlay: null,
  },
  satellite: {
    id: "satellite",
    label: "قمر صناعي",
    emoji: "🛰️",
    url: GOOGLE_BASE.replace("{layer}", "s"),
    subdomains: ["0", "1", "2", "3"],
    attribution: "© Google",
    maxZoom: 20,
    overlay: null,
  },
  hybrid: {
    id: "hybrid",
    label: "قمر + شوارع",
    emoji: "🌍",
    url: GOOGLE_BASE.replace("{layer}", "y"),
    subdomains: ["0", "1", "2", "3"],
    attribution: "© Google",
    maxZoom: 20,
    overlay: null,
  },
  terrain: {
    id: "terrain",
    label: "تضاريس",
    emoji: "⛰️",
    url: GOOGLE_BASE.replace("{layer}", "p"),
    subdomains: ["0", "1", "2", "3"],
    attribution: "© Google",
    maxZoom: 20,
    overlay: null,
  },
  osm: {
    id: "osm",
    label: "OSM",
    emoji: "🗺️",
    url: "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png",
    subdomains: ["a", "b", "c"],
    attribution: "© OpenStreetMap",
    maxZoom: 19,
    overlay: null,
  },
};

// Default: Google Maps roadmap (same visual as the user's reference screenshots)
export const DEFAULT_MAP_STYLE = "streets";

// Order in which the switcher chips are shown (most useful first)
export const MAP_STYLE_ORDER = ["streets", "satellite", "hybrid", "terrain", "osm"];
